import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState, useEffect } from 'react';
import Loader from 'react-loaders';
import React from 'react';
import img from '../../assets/images/profileImg.png';

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <div className="aboutContainer about-page" id="container">
        <div className="text-zone" id="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
        <div className="imageDiv">
          <img className="profile" src={img} alt="img" />
        </div>
          <p style={{ fontSize: '1.5rem', lineHeight: '2.2rem' }}>
            I am a full stack developer, coming from a graphic design and
            photography background. My previous experience shaped me into a
            creative thinker, and it has been a great transferable skill. Jumped
            into tech industry to utilize both side of my brain. It has been a
            great journey and looking to experience more of it.
          </p>
          <p style={{ fontSize: '1.5rem', lineHeight: '2.2rem' }}>
            {' '}
            Currently I am proficient in:  
            <b>
              JavaScript, React, React Native, GraphQL, MongDBNodeJS, SQL,
              HTML5/CSS6/SASS, Runy on Rails, Mocha & Chai, Storybook, Cypress{' '}
            </b>{' '}
            and more to go.
          </p>
          <p style={{ fontSize: '1.5rem', lineHeight: '2.2rem' }}>
            {' '}
            Now I am ready to work for you and help you build the smoothest and
            most awesome application possible.
          </p>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default About;
